module.exports = __webpack_public_path__ + "img/tg-icon.2b24465e.png";